'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '5.3.2';


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/version.js
// module id = 475
// module chunks = 168707334958949